// extracted by mini-css-extract-plugin
export var data_img = "index-module--data_img--602c4";
export var data_item = "index-module--data_item--16c0b";
export var rotate_line = "index-module--rotate_line--2567b";
export var upright_line = "index-module--upright_line--7f4ce";
export var wrapper = "index-module--wrapper--901b6";